import {
  getGlobalCssUrl,
  getComponentCssUrl,
} from '@/components/webcomponents/Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createDataTableTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('DataTable--wc.css')}" rel="stylesheet" />
`
  return t
}

const getTemplateDataTableStyles = () => createDataTableTemplate()
export { getTemplateDataTableStyles }
